const deliveryDummy = [
    { id: 1, label: '택배' },
    { id: 2, label: '직거래' },
  ];
export default deliveryDummy;